/**
 * Created on 2017/2/23.充值订单部分的常量
 */
/**
 */
define('constant/myaccount/balance.constant',[], function () {
    return {
        "CurrencyRate": 100,
        refundReasons: [
            {key: 1, value: '打款主体不一致'},
            {key: 2, value: '暂停推广'},
            {key: 3, value: '产品下架'},
            {key: 4, value: '终止合作'},
            {key: 5, value: '应用转移'},
            {key: 6, value: '业务调整'},
            {key: 7, value: '其他'},
        ],
        currencyTypes: {
            symbol: {
                EUR: "€",
                USD: "$",
                CNY: "¥",
                JPY: "JPY¥",
                GBP: "£"
            },
            currenLabel: {
                0: "EUR",
                1: "USD",
                2: "CNY",
                3: "JPY",
                4: "GBP"
            },
            currenLabelReverses: {
                EUR: 0,
                USD: 1,
                CNY: 2,
                JPY: 3,
                GBP: 4
            },
            currenRate: {
                EUR: 100,
                USD: 100,
                CNY: 100,
                JPY: 1,
                GBP: 100
            },
            threshold: {
                EUR: "42",
                USD: "50",
                CNY: "335",
                JPY: "5524",
                GBP: "36"
            }
        },
        refundReasonsFormatter: {
            "1": "打款主体不一致",
            "2": "暂停推广",
            "3": "产品下架",
            "4": "终止合作",
            "5": "应用转移",
            "6": "业务调整",
            "7": "其他",
        },
        refundStatus: {
            "6": "驳回",
            "8": "已退款",
            "7": "退款审核中",
            "11": "退款审核中",
            "21": "申请中",
            "22": "退款审核中",
            "23": "退款审核中",
            "24": "退款审核中",
            "25": "退款审核中",
            "26": "已撤销",
        },
        orderStatus: {
            "1": "待付款",
            "2": "交易成功",
            "3": "交易已撤销",
            "4": "交易已过期",
            "5": "待审核",
            "6": "审核不通过",
            "8": "退款成功",
            "9": "待审核",
            "10": "审核不通过",
            "11": "退款中",
            "12": "退款失败",
            "13": "待审核",
            "14": "到账中",
            "17": "失效审核中",
            "18": "失效审核中",
            "19": "失效失败",
            "20": "失效成功",
            "27": "待审核"
        },
        orderStatusTH: [{
            "id": "1",
            "name": "待付款"
        },
            {
                "id": "13",
                "name": "待审核"
            },
            {
                "id": "2",
                "name": "交易成功"
            },
            {
                "id": "3",
                "name": "交易已撤销"
            },
            {
                "id": "4",
                "name": "交易已过期"
            },
            {
                "id": "6",
                "name": "审核不通过"
            },
            {
                "id": "8",
                "name": "退款成功"
            },
            {
                "id": "11",
                "name": "退款中"
            },
            {
                "id": "12",
                "name": "退款失败"
            },
            {
                "id": "14",
                "name": "到账中"
            }],
        orderStatusTHP: [{ // 个人
            "id": "1",
            "name": "待付款"
        },
            {
                "id": "13",
                "name": "待审核"
            },
            {
                "id": "2",
                "name": "交易成功"
            },
            {
                "id": "3",
                "name": "交易已撤销"
            },
            {
                "id": "4",
                "name": "交易已过期"
            },
            {
                "id": "6",
                "name": "审核不通过"
            },
            {
                "id": "8",
                "name": "退款成功"
            },
            {
                "id": "11",
                "name": "退款中"
            },
            {
                "id": "12",
                "name": "退款失败"
            },
            {
                "id": "14",
                "name": "到账中"
            }],
        orderStatusTHYX: [{ // 耀星
            "id": "1",
            "name": "待付款"
        },
            {
                "id": "13",
                "name": "待审核"
            },
            {
                "id": "2",
                "name": "交易成功"
            },
            {
                "id": "3",
                "name": "交易已撤销"
            },
            {
                "id": "4",
                "name": "交易已过期"
            },
            {
                "id": "6",
                "name": "审核不通过"
            },
            {
                "id": "7",
                "name": "退款待审核"
            },
            {
                "id": "8",
                "name": "退款成功"
            },
            {
                "id": "11",
                "name": "退款中"
            },
            {
                "id": "12",
                "name": "退款失败"
            },
            {
                "id": "14",
                "name": "到账中"
            },
            {
                "id": "17",
                "name": "失效审核中"
            },
            {
                "id": "19",
                "name": "失效失败"
            },
            {
                "id": "20",
                "name": "失效成功"
            }

        ],
        contractType: {
            "1": "现金",
            "2": "框架合同",
            "3": "资源置换",
            "4": "赠送",
            "5": "纯赠送",
            "6": "消耗返利",
            "7": "消耗返利-应用市场推广",
            "8": "联运返利-游戏",
            "9": "联运返利-应用"
        },
        contractTypePersonal: {
            "1": "现金"
        },
        contractTypes: {
            "5": "纯赠送-华为自有媒体",
            "6": "消耗返利-华为自有媒体"
        },
        contractTypesPersonal: {
            "5": "纯赠送-华为自有媒体",
            "6": "消耗返利-华为自有媒体"
        },
        contractTypeTH: [
            {
                "id": "1",
                "name": "现金",
                "enIndex": 1
            },
            {
                "id": "14",
                "name": "现金-充赠",
                "tips": "该订单类型享受充赠政策的现金，不计入返利消耗，不允许退款",
                "enIndex": 1
            },
            {
                "id": "2",
                "name": "框架合同",
                "enIndex": 2
            },
            {
                "id": "3",
                "name": "资源置换",
                "enIndex": 3
            },
            {
                "id": "4",
                "name": "赠送",
                "enIndex": 4
            },
            {
                "id": "5",
                "name": "纯赠送",
                "enIndex": 5
            },
            {
                "id": "12",
                "name": "充值赠送",
                "tips": "该订单类型需搭配一定的返利金/授信/现金/后付费进行消耗",
                "enIndex": 8
            },
            {
                "id": "6",
                "name": "消耗返利-通用",
                "enIndex": 10
            },
            {
                "id": "9",
                "name": "消耗返利-应用市场推广",
                "enIndex": 12
            },
            {
                "id": "10",
                "name": "联运返利-游戏",
                "enIndex": 13
            },
            {
                "id": "11",
                "name": "联运返利-应用",
                "enIndex": 14
            }
        ],
        contractTypeTHP: [{ // 个人
            "id": "1",
            "name": "现金"
        }],
        contractTypeTHExtend: [
            {
                "id": "5",
                "name": "纯赠送-通用",
                "enIndex": 6
            },
            {
                "id": "7",
                "name": "纯赠送-华为自有媒体",
                "enIndex": 7
            }, {
                "id": "8",
                "name": "消耗返利-华为自有媒体",
                "enIndex": 11
            },
            {
                "id": "12",
                "name": "充值赠送-通用",
                "tips": "该订单类型需搭配一定的返利金/授信/现金/后付费进行消耗",
                "enIndex": 8
            },
            {
                "id": "13",
                "name": "充值赠送-华为自有媒体",
                "tips": "该订单类型需搭配一定的返利金/授信/现金/后付费进行消耗",
                "enIndex": 9
            }
        ],
        financialType: {
            "0": "充值",
            "1": "清退",
        },
        financialTypePersonal: {
            "0": "充值",
            "1": "清退",
        },
        financialTypeTH: [{
            "id": "0",
            "name": "充值"
        },
            {
                "id": "1",
                "name": "清退"
            }
        ],
        financialTypeTHP: [{
            "id": "0",
            "name": "充值"
        },
            {
                "id": "1",
                "name": "清退"
            }
        ],
        receiptStatus: {
            "1": "未开票",
            "2": "已开票",
            "3": "已退票",
            "4": "无需开票",
            "5": "开票中"
        },
        receiptStatusPersonal: {
            "1": "未开票",
            "2": "已开票",
            "3": "已退票",
            "5": "开票中"
        },
        refundReceiptStatus: {
            "0": "发票已抵扣",
            "1": "发票未抵扣",
            "2": "发票遗失",
            "3": "发票遗失",
            "4": "未开票",
            "5": "已开票",
        },
        receiptStatusTH: [{
            "id": "1",
            "name": "未开票"
        },
            {
                "id": "2",
                "name": "已开票"
            },
            {
                "id": "3",
                "name": "已退票"
            },
            {
                "id": "4",
                "name": "无需开票"
            },
            {
                "id": "5",
                "name": "开票中"
            }],
        receiptStatusTHP: [{ // 个人
            "id": "1",
            "name": "未开票"
        },
            {
                "id": "2",
                "name": "已开票"
            },
            {
                "id": "3",
                "name": "已退票"
            },
            {
                "id": "5",
                "name": "开票中"
            }],
        isForCpType: {
            "0": "代理公司",
            "1": "自己公司"
        },
        refundType: {
            "0": "线下退款",
            "1": "线上退款"
        },
        purchaseType: {
            "0": "线上付款",
            "1": "线下付款"
        },
        purchaseTypeTH: [{
            "id": "0",
            "name": "线上付款"
        }, {
            "id": "1",
            "name": "线下付款"
        }],
        purchaseTypeTHP: [{
            "id": "0",
            "name": "线上付款"
        }],
        "ware": [{
            "id": 26,
            "name": "应用市场推广基金"
        },
            {
                "id": 29,
                "name": "鲸鸿动能广告投放基金"
            },
            {
                "id": 33,
                "name": "激励推广金"
            },
            {
                "id": 30,
                "name": "通用基金"
            },
        ],
        "yxqware": [{
            "id": 26,
            "name": "应用市场推广耀星流量券"
        },
            {
                "id": 29,
                "name": "鲸鸿动能耀星流量券"
            }
        ],
        "personalware": [{
            "id": 30,
            "name": "通用基金"
        }],
        "CustomerServiceQQ": {
            "display": 1,
            "QQ": 4000886183,
            "companyWebSite": "/consumer/cn/"
        },
        "yxqwareType": {
            26: "应用市场推广耀星流量券",
            29: "鲸鸿动能耀星流量券"
        },
        "purchaseTypeTHPType": {
            26: "应用市场推广基金",
            29: "鲸鸿动能广告投放基金",
            33: "激励推广金",
            30: "通用基金"
        },
        serviceName: 'HuaweiDeveloper',
        currentUnits: {'0': '￥', '1': '￥', '2': '流量'},
        currentTypes: {'0': 'CNY', '1': 'CNY', '2': 'YXQ'},
        currenRate: {
            "EUR": 100,
            "USD": 100,
            "CNY": 100,
            "JPY": 1,
            "GBP": 100,
            "YXQ": 100,
            "HKD": 100
        },
        accountnTypes: {
            promoteAccount: {'0': '应用市场推广基金', '1': '应用市场推广基金', '2': '应用市场推广耀星流量券账户'},
            ppsAccount: {'0': '鲸鸿动能广告投放基金', '1': '鲸鸿动能广告投放基金', '2': '鲸鸿动能耀星流量券账户'}
        },
        agreementNames: {'0': '华为合作伙伴付费服务协议', '1': '华为合作伙伴付费服务协议'},
        refundContactInfo: {
            person: '包旭清',
            phone: '025-56622212'
        }
    }

});

